module.exports = __webpack_public_path__ + "static/img/jobs_info3.6b8c763.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jobs_info3.png
// module id = uRBG
// module chunks = 94